import React from "react";
import styled from "styled-components";
import Loader from "./loader";

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 50px 0;
`;

const PageLoader = () => {
  return (
    <Wrapper>
      <Loader size="150" />
    </Wrapper>
  )
}

export default React.memo(PageLoader)